import React, {useState} from "react";
import {connect} from "react-redux";
import Modal from "../common/Modal/Modal";
import {useSubmitGuard} from "../common/Helpers";

export function InvitePersonModal(props) {

const [email, setEmail] = useState("");
const [roleCa, setRoleCa] = useState(false);
const [roleCreator, setRoleCreator] = useState(false);
const {isSubmitting, guardedSubmit} = useSubmitGuard();

// Company Admin ("Super User") implies Editor too, matching PersonDetails.js's own
// checkbox behavior when admitting a join request
const handleToggleRoles = (e) => {
    if (e.target.id === "invite-company-admin") {
        if (!roleCa && !roleCreator) setRoleCreator(true);
        setRoleCa(!roleCa);
    } else {
        setRoleCreator(!roleCreator);
    }
}

const handleSubmit = guardedSubmit((e) => {
    e.preventDefault();
    email && props.onSubmit(email, {"Company Admin": roleCa, Creator: roleCreator});
});

    return (
        <Modal blurBack={true} hasCloseButton={true} handleClose={(e) => props.handleClose(e)} >
            <h2 className="title2 heavy gap-below-s">Invite someone to your company</h2>
            <p className="content1 light-black multiline gap-below-m">They'll get an email to create their account -- no approval step needed afterward, since you're choosing their permissions right now.</p>
            <form className="form" onSubmit={(e) => handleSubmit(e)}>
                <div className="inputs-wrapper gap-below-s">
                    <div className="input-basic addspace">
                        <input
                            type="email"
                            name="invite_email"
                            id="invite_email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            required
                        />
                        <label htmlFor="invite_email">Email<span> *</span></label>
                    </div>
                </div>
                <div className="checkbox-wrapper">
                    <input
                        className="typical-checkbox"
                        type="checkbox"
                        id="invite-company-admin"
                        checked={roleCa}
                        onChange={(e) => handleToggleRoles(e)}
                    />
                    <label htmlFor="invite-company-admin" className="content1 light-black multiline">Super User</label>
                </div>
                <div className="checkbox-wrapper gap-below-s">
                    <input
                        className="typical-checkbox"
                        type="checkbox"
                        id="invite-creator"
                        checked={roleCreator}
                        onChange={(e) => handleToggleRoles(e)}
                        disabled={roleCreator && roleCa}
                    />
                    <label htmlFor="invite-creator" className="content1 light-black multiline">Editor</label>
                </div>
                <div className="flex-row ">
                    <button
                        id="submit_invite"
                        className="iblock btn expand pri gap-right-xs"
                        disabled={!email || isSubmitting}
                        type="submit"
                    >{isSubmitting ? "Please wait..." : "Send Invite"}</button>
                    <button type="button" disabled={isSubmitting} className="iblock btn expand sec" onClick={(e) => props.handleClose(e)} >Cancel</button>
                </div>
            </form>
        </Modal>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(InvitePersonModal);
